import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import Workspace from '../components/formalrv/Workspace'
import Explorer from '../components/formalrv/Explorer'
import Playground from '../components/formalrv/Playground'
import { formalrvExplorerApi, type FRXIndex } from '../utils/api'

const PLAYGROUND = 'new'

export default function CompilerExplorerPage() {
  const [params, setParams] = useSearchParams()
  const [index, setIndex] = useState<FRXIndex | null>(null)
  const [error, setError] = useState<string | null>(null)
  const exampleId = params.get('example') ?? 'pauli'
  const run = params.get('run')

  useEffect(() => {
    document.title = 'Compiler Explorer · FT Shor Leaderboard'
    formalrvExplorerApi.getIndex().then(setIndex).catch(e => setError(e?.message || 'Failed to load'))
  }, [])

  const select = (example: string, runId: string | null = null) => {
    const next = new URLSearchParams({ example })
    if (runId) next.set('run', runId)
    setParams(next, { replace: true })
  }

  const categories = index?.categories?.length ? index.categories : [{ id: 'ladder', title: 'Examples', summary: '' }]
  const picker = index && (
    <select value={exampleId} onChange={e => select(e.target.value)} aria-label="Example"
      className="h-7 pl-2 pr-6 rounded-md border border-qcloud-border bg-white text-xs font-mono text-qcloud-text max-w-[16rem]">
      {categories.map(cat => {
        const list = index.examples.filter(e => (e.category ?? 'ladder') === cat.id)
        return list.length > 0 && (
          <optgroup key={cat.id} label={cat.title}>
            {list.map(e => <option key={e.id} value={e.id}>{e.unit}.prog · {e.title}</option>)}
          </optgroup>
        )
      })}
      <optgroup label="Yours">
        <option value={PLAYGROUND}>Main.prog · your program</option>
      </optgroup>
    </select>
  )

  return (
    <Workspace crumb="Compiler Explorer">
      {error && <div className="rounded-lg border border-rose-200 bg-rose-50 p-4 text-sm text-rose-800">{error}</div>}
      {index && (exampleId === PLAYGROUND
        ? <Playground index={index} picker={picker} />
        : <Explorer key={exampleId} exampleId={exampleId} variantId={run} onVariantChange={id => select(exampleId, id)} toolbar={picker} />)}
    </Workspace>
  )
}
